/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable indent */
let partSolutionsSubscriptionKey = '7cd158dbe8404557be1c4ab6a6993ed4';
export default {
  GenerateMident: async function (partNumber, catalog, partSolutionsAPI) {
    let mident;
    psol.core.setApiKey(partSolutionsSubscriptionKey);
    psol.core.setUserInfo({
      server_type: 'SUPPLIER_EXTERNAL_parker-embedded'
    });
    psol.core.setServiceBaseUrl(partSolutionsAPI);
    // use local var for jQuery.
    var $ = jQuery;
    // do a reverse lookup with the part number
    await psol.core
      .ajaxGetOrPost({
        url: psol.core.getServiceBaseUrl() + '/service/reversemap',
        data: {
          catalog: catalog,
          part: partNumber,
          exact: '0'
        }
      })
      .then(function (reverseMapResult) {
        mident = reverseMapResult.mident || '';
      });
    return mident;
  },
  GeneratePreviewView: function (
    previewType,
    mident,
    isManifoldProduct,
    partSolutionsAPI,
    sessionData,
    partNumberString,
    isInitialLoad
  ) {
    // use local var for jQuery.
    var $ = jQuery;
    // prepare 3d viewer.
    if (previewType == '3D') {
      var radialMenuActions3d = [
        {
          name: 'menu_shading',
          subActions: ['actLine', 'actShade', 'actShadeLine', 'actSAO']
        },
        {
          name: 'menu_rotation',
          subActions: [
            'actFront',
            'actBack',
            'actLeft',
            'actRight',
            'actTop',
            'actBottom',
            'actIsometric',
            'actAnimate'
          ]
        },
        {
          name: 'menu_vr',
          subActions: [
            'actVR',
            'actAnaglyph',
            'actBluebox',
            'actDreamocHD3',
            'actDreamocXL2',
            'actDreamocMOBILE',
            'actPseudoFullscreen',
            'actHoloLens'
          ]
        },
        {
          name: 'menu_special',
          subActions: [
            'actZoomall',
            'actZoomObject',
            'actSaveCameraParams',
            'actCut',
            'actCustomDimensions',
            'actMeasureGrid',
            'actExplosion',
            'actLabels',
            'actHotSpots',
            'actDrawing',
            'actCameraBackground',
            'actScreenShot'
          ]
        }
      ];
      var favoriteActions3d = [
        'actFullscreen',
        'actMeasureGrid',
        // 'actCut',
        // 'actDreamocHD3',
        'actAnimate',
        'actIsometric',
        'actCustomDimensions',
        'actLine',
        'actShadeLine',
        // 'actEnv',
        'actToggleRotationMode'
        // 'actEnableHotSpots',
        // 'actTeleport',
        // 'actBluebox'
      ];
      var webViewer3DSettings = {
        $container: $('#cnsWebViewer3d'),
        viewerBackendType: psol.components.WebViewer3D.ViewerBackends.WebGL,
        devicePixelRatio: window.devicePixelRatio,
        radialMenuActions: radialMenuActions3d,
        favoriteActions: favoriteActions3d,
        webglViewerSettings: {
          ColorTL: '#ffffff',
          ColorTR: '#ffffff',
          ColorML: '#ffffff',
          ColorMR: '#ffffff',
          ColorBL: '#ffffff',
          ColorBR: '#ffffff',
          rotationCube: true,
          showLogo: true,
          // logoTexture: 'cns_logo.jpg',
          // logoScaleFactor: 0.5,
          // logoMixFactor: 0.5,
          material: {
            preset: 'pcloud',
            edit: false
          },
          measureGrid: {
            colors: {
              dimensions: '#000000',
              outline: '#0000ff',
              grid: '#757575',
              unit: 'INCH'
            }
          },
          helperOptions: {
            gridOn: false,
            axisOn: false
          },
          shadeMode: psol.components.WebViewer3D.ShadeModes.ShadeAndLines,
          enableEditableDimensions: true,
          showPartNameTooltip: true
        }
      };
      var webviewer3d = new psol.components.WebViewer3D(webViewer3DSettings);
      if (isManifoldProduct) {
        psol.core.setApiKey(partSolutionsSubscriptionKey);
        psol.core.setUserInfo({
          server_type: 'SUPPLIER_EXTERNAL_parker-embedded',
          firm: 'parker'
        });
        psol.core.setServiceBaseUrl(partSolutionsAPI);
        psol.order
          .orderData(mident, '', '', 'PARTJAVA', {}, false)
          .then(function (downloadData) {
            // Show the component.
            // Create a WebViewer3D component.
            webviewer3d.show().done(function () {
              webviewer3d.loadByUrl(
                downloadData.parts[0].files[0]?.downloadurl
              );
              $('.psol-comp-viewbase-iconbutton').on('click', function () {
                PreviewInteractionDataLayer(
                  '3D',
                  sessionData,
                  partNumberString
                );
              });
            });
          });
      } else {
        webviewer3d.show().then(function () {
          webviewer3d.loadByVarset(null, null, mident);
          $('.psol-comp-viewbase-iconbutton').on('click', function () {
            PreviewInteractionDataLayer('3D', sessionData, partNumberString);
          });
        });
      }
    }
    //prepare 2d viewer.
    if (previewType == '2D') {
      // prepare favorite actions for 2d viewer.
      var favoriteActions2d = [];

      // prepare 2d viewer settings.
      var webViewer2DSettings = {
        $container: $('#cnsWebViewer2d'),
        viewerType: psol.components.WebViewer2D.ViewType.DERIVATION_VIEW,
        favoriteActions: favoriteActions2d
      };

      // initialize 2d viewer
      var webviewer2d = new psol.components.WebViewer2D(webViewer2DSettings);
      webviewer2d.show().then(function () {
        webviewer2d.loadByVarset(null, null, mident);
        $('.psol-comp-webviewer2d-render-area').on('click', function () {
          PreviewInteractionDataLayer('2D', sessionData, partNumberString);
        });
        $('.psol-comp-webviewer2d-selection').on('change', function () {
          PreviewInteractionDataLayer('2D', sessionData, partNumberString);
        });
      });
    } // show in 2d viewer.

    if (!isInitialLoad)
      PreviewInteractionDataLayer(previewType, sessionData, partNumberString);
  },
  GenerateCADDownload: async function (
    cadType,
    mident,
    partNumber,
    catalog,
    cadName,
    manufacturingDivision,
    partNumberString,
    isManifoldProduct,
    bomItems,
    configModel,
    uniquePartIdentifier
  ) {
    let downloadFlagType = { downloadflags: 'ZIP' };
    var date = new Date();
    var date_format_str =
      date.getFullYear().toString() +
      '-' +
      ((date.getMonth() + 1).toString().length == 2
        ? (date.getMonth() + 1).toString()
        : '0' + (date.getMonth() + 1).toString()) +
      '-' +
      (date.getDate().toString().length == 2
        ? date.getDate().toString()
        : '0' + date.getDate().toString()) +
      '_' +
      (date.getHours().toString().length == 2
        ? date.getHours().toString()
        : '0' + date.getHours().toString()) +
      '-' +
      (parseInt(date.getMinutes()).toString().length == 2
        ? parseInt(date.getMinutes()).toString()
        : '0' + parseInt(date.getMinutes()).toString()) +
      '-' +
      (parseInt(date.getSeconds()).toString().length == 2
        ? parseInt(date.getSeconds()).toString()
        : '0' + parseInt(date.getSeconds()).toString());

    if (!isManifoldProduct)
      downloadFlagType.zipfilename = catalog.toUpperCase() + '_' + partNumber;
    if (manufacturingDivision == '687492')
      downloadFlagType.zipfilename =
        catalog.toUpperCase() + '_' + date_format_str;
    if (isManifoldProduct) {
      if (uniquePartIdentifier) {
        partNumber = uniquePartIdentifier;
      }
      downloadFlagType.zipfilename = partNumber + '_' + date_format_str;
      downloadFlagType.customfilename = partNumber + '_' + date_format_str;
      downloadFlagType.ExportOption_PDFDATASHEET = [
        'useDefaultTemplate=0',
        'useTemplateFile=1',
        'templateFile=$CADENAS_DATA/23d-libs/parkerpdn/_templates/parkerpdn_addafold.template',
        "addKeyValues='NN'='" +
          configModel +
          "'|'NB'='" +
          partNumber +
          "'|'LINA'='" +
          partNumber +
          "'|'bomItems'='" +
          bomItems +
          "'"
      ];
    }
    await psol.order
      .orderData(mident, '', '', cadType, downloadFlagType, false)
      .then(function (downloadData) {
        window.open(downloadData.zipfile, '_blank');
        let fileName = downloadData.zipfile.replace(/^.*[\\/]/, '');
        window['dataLayer'].push({
          event: 'select_download_type',
          support_title: fileName,
          support_type: 'Configurator CAD',
          support_sub_category: 'N/A',
          file_type: cadName,
          configuration_code: partNumberString,
          content_owner: manufacturingDivision
        });
        CSATCAD();
      });
  }
};

function PreviewInteractionDataLayer(
  previewType,
  sessionData,
  partNumberString
) {
  window['dataLayer'].push({
    event: 'preview_interaction',
    preview_mode: previewType,
    content_owner: sessionData.manufacturingDivision,
    nav_owner: sessionData.countryId,
    product_series_name: sessionData.seriesName,
    product_series_id: sessionData.productId,
    product_id: 'N/A',
    part_name: partNumberString + ' - ' + sessionData.seriesName,
    part_number: partNumberString,
    configuration_code: partNumberString
  });
}
